import { MapPin, Clock, Navigation, Phone, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WHATSAPP_NUMBER, GOOGLE_PLACE } from "@/lib/config";

const ADDRESS = "C. de María Zayas Sotomayor, 18, 50018 Zaragoza";
const MAPS_QUERY = encodeURIComponent(ADDRESS);

const isOpenNow = () => {
  const madrid = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Madrid" }));
  const mins = madrid.getHours() * 60 + madrid.getMinutes();
  return mins >= 7 * 60 + 30 && mins < 22 * 60 + 30;
};

export const LocationHours = () => {
  const open = isOpenNow();
  return (
    <section id="ubicacion" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-slate-900">Horario y Cómo Llegar</h2>
          <p className="mt-3 text-slate-600">Estamos en el barrio del Actur, en Zaragoza. ¡Te esperamos!</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-8 items-stretch">
          <div className="md:col-span-5 flex flex-col gap-5 md:gap-6">
            <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5 sm:p-7 flex-1" data-testid="hours-card">
              <div className="flex items-center justify-between mb-4">
                <span className="inline-flex items-center gap-2 font-heading font-semibold text-lg text-slate-900">
                  <Clock className="h-5 w-5 text-cyan-500" /> Horario
                </span>
                <span data-testid="open-now-badge"
                  className={`text-xs font-semibold px-3 py-1 rounded-full ${open
                    ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                  {open ? "Abierto ahora" : "Cerrado ahora"}
                </span>
              </div>
              <p className="font-heading font-bold text-3xl text-cyan-600">7:30 – 22:30</p>
              <p className="text-slate-600 mt-1">Todos los días, incluidos festivos</p>
              <p className="text-sm text-slate-500 mt-4">
                Autoservicio disponible durante todo el horario. Zona de café y snacks mientras esperas.
              </p>
            </div>
            <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5 sm:p-7" data-testid="address-card">
              <span className="inline-flex items-center gap-2 font-heading font-semibold text-lg text-slate-900 mb-3">
                <MapPin className="h-5 w-5 text-cyan-500" /> Dirección
              </span>
              <p className="text-slate-700">{ADDRESS}</p>
              <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-2 sm:gap-3 mt-5">
                <Button asChild data-testid="directions-btn" className="bg-cyan-500 hover:bg-cyan-600 rounded-full px-4 sm:px-6 h-10">
                  <a href={`https://www.google.com/maps/dir/?api=1&destination=${MAPS_QUERY}`}
                    target="_blank" rel="noopener noreferrer">
                    <Navigation className="h-4 w-4 mr-2" /> Cómo llegar
                  </a>
                </Button>
                <Button asChild variant="outline" data-testid="call-btn" className="rounded-full px-4 sm:px-6 h-10 border-slate-300">
                  <a href={`tel:+${WHATSAPP_NUMBER}`}>
                    <Phone className="h-4 w-4 mr-2" /> <span className="sm:hidden">Llamar</span><span className="hidden sm:inline">628 76 96 27</span>
                  </a>
                </Button>
                <Button asChild variant="outline" data-testid="google-profile-btn" className="col-span-2 rounded-full px-4 sm:px-6 h-10 border-slate-300">
                  <a href={GOOGLE_PLACE.mapsUrl} target="_blank" rel="noopener noreferrer">
                    <Star className="h-4 w-4 mr-2 fill-amber-400 text-amber-400" /> {GOOGLE_PLACE.rating.toLocaleString("es-ES")} en Google
                  </a>
                </Button>
              </div>
            </div>
          </div>
          <div className="md:col-span-7">
            <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-sm h-full min-h-[280px] md:min-h-[420px]" data-testid="map-embed">
              <iframe
                title="Mapa Lavandería Ozono"
                src={`https://www.google.com/maps?q=${MAPS_QUERY}&output=embed&z=16`}
                className="w-full h-full min-h-[280px] md:min-h-[420px]"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
